import React, { useEffect, useState } from "react";
import { AgentSidebarItem } from "./AgentSidebarItem";
import backgroundImage from "../assets/office-background.png";
import tableImage from "../assets/table.png";
import chairImage from "../assets/chair.png";
import logoImage from "../assets/logo.png";
import {
  ChevronLeft,
  ChevronLeftCircle,
  ChevronRight,
  ChevronRightCircle,
} from "lucide-react";
import { TaskManager } from "./TaskManager";
import { FileBox } from "./FileBox";
import { BottomNavigation } from "./BottomNavigation";
import { AgentChatbot } from "./AgentChatbot";
import { useLocation, useNavigate } from "react-router-dom";
import { mockAgents } from "../App";
import FileManager from "./FileManager";
// import axios from "axios";
export function BoardroomScreen({
  userDetails,
  magicCode,
  API_BASE_URL,
  setUserDetails,
  setMagicCode,
}) {
  const location = useLocation();
  const navigate = useNavigate();

  // Retrieve selected agents passed from Selection page
  const selectedAgentsBoardroom =
    location.state?.selectedAgents ||
    JSON.parse(localStorage.getItem("selectedAgents"));
  console.log("selectedAgentsBoardroom", selectedAgentsBoardroom);
  // If no agents (e.g., user refreshed or came directly), go back to selection page
  const storedMagicCode = localStorage.getItem("magicCode");

  // Component state
  const [activeTab, setActiveTab] = useState("aiagent");
  const [showTaskManager, setShowTaskManager] = useState(false);
  const [showFileBox, setShowFileBox] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeChatAgent, setActiveChatAgent] = useState(null);
  const [allAgentsState, setAllAgentsState] = useState(mockAgents);
  const [selectedAgents, setSelectedAgents] = useState(selectedAgentsBoardroom);
  const [agentChange, setAgentChange] = useState(false);
  const [showFilesPopup, setShowFilesPopup] = useState(false);
  const [webhookAgentUrl, setWebhookAgentUrl] = useState("");
  const [isChatFullScreen, setIsChatFullScreen] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [messages, setMessages] = useState([]);

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(location.search);
  //   const codeFromUrl = searchParams.get("magicCode");

  //   if (codeFromUrl) {
  //     setMagicCode(codeFromUrl);
  //     console.log("✅ Magic Code found in URL:", codeFromUrl);
  //     // 👉 you can now send this code to backend or validate it here
  //   } else {
  //     // If no magicCode query param exists, append ?magicCode=
  //     navigate(`${location.pathname}?magicCode=`, { replace: true });
  //   }
  // }, [location, navigate]);

  // React.useEffect(() => {
  //   if (selectedAgents.length === 0) {
  //     navigate("/");
  //   }
  // }, [selectedAgents, navigate]);

  const handleAgentClick = (agent) => {
    setActiveChatAgent(agent);
    setAgentChange(!agentChange);
  };

  const handleCloseChatbot = () => {
    setActiveChatAgent(null);
  };

  // Check if agent already selected
  const isAgentSelected = (agentId) => {
    return selectedAgents.some((agent) => agent.id === agentId);
  };

  const isSelectionFull = selectedAgents.length >= 5;

  // Chair positions
  const getChairPosition = (index, totalChairs) => {
    const spacing = 140;
    const startX = (-(totalChairs - 1) * spacing) / 2;
    const x = startX + index * spacing;
    const y = -40;
    return { x, y, angle: 0 };
  };

  // Sidebar toggle
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Handle Bottom Navigation tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "taskboard") {
      setShowTaskManager(true);
      setShowFileBox(false);
    } else if (tab === "filebox") {
      setShowFileBox(true);
      setShowTaskManager(false);
    } else {
      setShowTaskManager(false);
      setShowFileBox(false);
    }
  };

  const handleRemoveAgent = (agentId) => {
    setSelectedAgents(selectedAgents.filter((agent) => agent.id !== agentId));
  };
  const handleSelectAgent = (agent) => {
    if (
      selectedAgents.length < 5 &&
      !selectedAgents.find((a) => a.id === agent.id)
    ) {
      setSelectedAgents([...selectedAgents, agent]);
    }
  };
  const toggleFilesPopup = () => {
    setShowFilesPopup(!showFilesPopup);
  };

  // THIS IS THE CODE FOR THE MOBILE BOARDROOM SCREEN
  // slider code

  // Mobile/Tablet slider state
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isTabletView, setIsTabletView] = useState(false);

  // Detect screen size changes
  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsMobileView(width < 768);
      setIsTabletView(width >= 768 && width < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);
  useEffect(() => {
    if (selectedAgents.length === 2 && currentSlide === 2) {
      setCurrentSlide(1);
    }
  }, [selectedAgents, currentSlide]);

  // Calculate slides per view based on screen size
  const getSlidesPerView = () => {
    if (isMobileView) return 1;
    if (isTabletView) return 2;
    return selectedAgents.length; // Desktop shows all
  };

  const slidesPerView = getSlidesPerView();
  const totalSlides = Math.ceil(selectedAgents.length / slidesPerView);

  // Navigation for slider
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  // Get agents for current slide
  const getCurrentSlideAgents = () => {
    const startIndex = currentSlide * slidesPerView;
    return selectedAgents.slice(startIndex, startIndex + slidesPerView);
  };

  return (
    <div className="boardroom-container">
      {/* Background */}
      <div className="background-wrapper">
        <img
          src={backgroundImage}
          alt="Office background"
          className="background-image"
        />
        <div className="background-overlay"></div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Top Controls */}
        <div className="top-controls">
          <div className="logo-wrapper">
            <img src={logoImage} alt="TIDE 360" className="company-logo" />
          </div>
          <button
            onClick={() => navigate(`/select-agent/chat/${storedMagicCode}`)}
            className="back-button"
          >
            Back
          </button>
        </div>

        {/* Task Board Title */}
        <div className="task-board-container">
          <div className="task-board">
            <h2 className="task-board-title">Task Board</h2>
          </div>
        </div>

        {/* Agent Profile Images Above Task Board */}
        <div className="agent-profiles-container">
          <div className="agent-profiles-grid">
            {selectedAgents.slice(0, 4).map((agent) => (
              <div key={agent.id} className="agent-profile-item">
                <button
                  onClick={() => handleAgentClick(agent)}
                  className="agent-profile-button"
                >
                  <div className="agent-selected-img">
                    <img
                      src={agent.image}
                      alt={agent.name}
                      className="agent-profile-image"
                    />
                  </div>
                </button>
                <div className="agent-badge">
                  <span className="agent-name-badge">{agent.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Table + Chairs */}
        <div className="boardroom-setup">
          <div className="table-chairs-container">
            {/* Table */}
            <div className="table-container">
              <img
                src={tableImage}
                alt="Boardroom table"
                className="table-image"
              />
              {/* Steam above left mug */}
              <div className="steam steam-left absolute"></div>

              {/* Steam above right mug */}
              <div className="steam steam-right absolute"></div>
            </div>

            {/* Chairs with Agents */}
            {selectedAgents.map((agent, index) => {
              const position = getChairPosition(index, selectedAgents.length);
              return (
                <div
                  key={agent.id}
                  className="chair-agent-wrapper"
                  style={{
                    left: `calc(50% + ${position.x}px)`,
                    bottom: `calc(8rem + ${-position.y}px)`,
                    transform: "translateX(-50%)",
                  }}
                >
                  <div className="chair-container">
                    <img
                      src={chairImage}
                      alt="Office chair"
                      className="chair-image"
                    />
                    <div className="person-container">
                      {agent?.imageSitting && (
                        <img
                          src={agent?.imageSitting}
                          alt={`${agent.name} seated`}
                          className="person-image"
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}

            {/* Empty Chairs */}
            {selectedAgents.length < 5 &&
              Array.from({ length: 5 - selectedAgents.length }).map(
                (_, emptyIndex) => {
                  const actualIndex = selectedAgents.length + emptyIndex;
                  const position = getChairPosition(actualIndex, 5);
                  return (
                    <div
                      key={`empty-${emptyIndex}`}
                      className="chair-agent-wrapper"
                      style={{
                        left: `calc(50% + ${position.x}px)`,
                        bottom: `calc(8rem + ${-position.y}px)`,
                        transform: "translateX(-50%)",
                      }}
                    >
                      <img
                        src={chairImage}
                        alt="Empty chair"
                        className="empty-chair-image"
                      />
                    </div>
                  );
                }
              )}
          </div>
        </div>
      </div>
      {/* slider for mobile view */}

      {/* Mobile/Tablet View - Slider */}
      {(isMobileView || isTabletView) && (
        <div className="mobile-slider-container">
          {/* Slider Content */}
          <div className="agents-slider">
            <div
              className="slider-track"
              style={{
                transform: `translateX(-${
                  currentSlide * (100 / slidesPerView)
                }%)`,
              }}
            >
              {selectedAgents.map((agent, index) => (
                <div
                  key={agent.id}
                  className="slider-slide"
                  style={{
                    width: `${100 / slidesPerView}%`,
                  }}
                >
                  <div className="mobile-agent-card">
                    {/* Agent Info */}
                    <div className="mobile-agent-info">
                      <button
                        onClick={() => handleAgentClick(agent)}
                        className="mobile-agent-button"
                      >
                        <div className="mobile-agent-img">
                          <img
                            src={agent.image}
                            alt={agent.name}
                            className="mobile-agent-profile-image"
                          />
                        </div>
                      </button>
                      <div className="mobile-agent-badge">
                        <span className="mobile-agent-name">{agent.name}</span>
                      </div>
                    </div>
                    {/* Chair */}
                    <div className="mobile-chair-container">
                      <img
                        src={chairImage}
                        alt="Office chair"
                        className="mobile-chair-image"
                      />
                      <div className="mobile-person-container">
                        {agent?.imageSitting && (
                          <img
                            src={agent?.imageSitting}
                            alt={`${agent.name} seated`}
                            className="mobile-person-image"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {/* Slider Navigation */}
            {totalSlides > 1 && (
              <div className="slider-navigation">
                <button
                  onClick={prevSlide}
                  className="slider-nav-button slider-prev"
                  aria-label="Previous agents"
                >
                  <ChevronLeftCircle size={32} />
                </button>

                <div className="slider-indicators">
                  {Array.from({ length: totalSlides }).map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentSlide(index)}
                      className={`slider-indicator ${
                        index === currentSlide ? "active" : ""
                      }`}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>

                <button
                  onClick={nextSlide}
                  className="slider-nav-button slider-next"
                  aria-label="Next agents"
                >
                  <ChevronRightCircle size={32} />
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {/* Mobile/Tablet View - Slider */}
      {/* Sidebar */}
      <div
        className={`sidebar-container ${
          isSidebarOpen ? "sidebar-open" : "sidebar-closed"
        }`}
      >
        <button className="sidebar-toggle" onClick={toggleSidebar}>
          {isSidebarOpen ? (
            <ChevronRight className="toggle-icon" />
          ) : (
            <ChevronLeft className="toggle-icon" />
          )}
        </button>
        {allAgentsState?.length > 0 && (
          <div className="sidebar">
            <div className="sidebar-content">
              {allAgentsState?.map((agent) => (
                <AgentSidebarItem
                  key={agent.id}
                  agent={agent}
                  isSelected={isAgentSelected(agent.id)}
                  onSelect={(agent) => {
                    handleSelectAgent(agent);
                  }}
                  onExclude={(id) => {
                    handleRemoveAgent(id);
                  }}
                  isDisabled={isSelectionFull && !isAgentSelected(agent.id)}
                  selectedAgents={selectedAgents}
                />
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Bottom Navigation */}
      <BottomNavigation activeTab={activeTab} onTabChange={handleTabChange} />

      {/* Overlays */}
      {showTaskManager && (
        <div className="overlay">
          <TaskManager onClose={() => setShowTaskManager(false)} />
        </div>
      )}

      {showFileBox && (
        <div className="overlay">
          <FileBox onClose={() => setShowFileBox(false)} />
        </div>
      )}

      {/* Agent Chatbot Panel */}
      {activeChatAgent && (
        <div className={`chatbot-panel ${isChatFullScreen ? "w-full" : ""}`}>
          <AgentChatbot
            agent={activeChatAgent}
            onClose={handleCloseChatbot}
            userDetails={userDetails}
            agentChange={agentChange}
            setShowFilesPopup={setShowFilesPopup}
            setWebhookAgentUrl={setWebhookAgentUrl}
            setCompanyName={setCompanyName}
            companyName={companyName}
            webhookAgentUrl={webhookAgentUrl}
            messages={messages}
            setMessages={setMessages}
            setIsChatFullScreen={setIsChatFullScreen}
            isChatFullScreen={isChatFullScreen}
          />
        </div>
      )}

      {showFilesPopup && (
        <div className="fixed inset-0  bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-0 rounded-lg max-w-2xl w-full relative">
            <div className="flex justify-between items-center absolute top-5 right-5 w-full">
              <div></div>
              <button
                onClick={toggleFilesPopup}
                className="text-gray-500 hover:cursor-pointer hover:text-gray-200"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <FileManager
              setMessages={setMessages}
              fallBackDetails={userDetails}
              activeAgent={activeChatAgent}
              webhookAgentUrl={webhookAgentUrl}
              companyName={companyName}
              user={userDetails}
              actions={{ toggleFilesPopup }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
